import { render, staticRenderFns } from "./SharedSliderCompareView.vue?vue&type=template&id=dd2f1f4a&"
import script from "./SharedSliderCompareView.vue?vue&type=script&lang=js&"
export * from "./SharedSliderCompareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports